import IClientState from "./IClientState";

const ClientReducers =  {
    SAVE_CLIENTS:saveClients
}

function saveClients(state:IClientState, action:any) {
    return { ...state, ...{clients:action.clients} };

}

export default ClientReducers
